import { render, staticRenderFns } from "./observed_01.vue?vue&type=template&id=20ce9521&"
import script from "./observed_01.vue?vue&type=script&lang=js&"
export * from "./observed_01.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports